import { envConfig } from "./env";

export const FEATURE_FLAGS = {
  imbox: {
    show: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_IMBOX),
  },
  checkout: {
    giftcards: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS,
    ),
    adyen: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_ADYEN),
    walley: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_WALLEY),
    walleyWidget: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_CART_WALLEY_WIDGET,
    ),
    giftCardChangeButton: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS_CHANGE_BUTTON,
    ),
    madeToOrderNotification: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_CHECKOUT_MADE_TO_ORDER,
    ),
    eurobonus: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_EUROBONUS),
  },
  customerService: {
    emailLink: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_EMAIL_LINK,
    ),
    phoneLink: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_PHONE_LINK,
    ),
    imboxButton: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_IMBOX_BUTTON,
    ),
  },
  discountPopup: {
    show: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_SHOW_DISCOUNT_POPUP),
  },
  searchEngine: {
    exploded: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_SEARCH_ENGINE_EXPLODE_PRODUCTS,
    ),
  },
  product: {
    newProductPage: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_PRODUCT_NEW_PRODUCT_PAGE,
    ),
    contentfulParametrics: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_PRODUCT_CONTENTFUL_PARAMETRICS,
    ),
    newProductGallery: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_PRODUCT_NEW_GALLERY,
    ),
    googleAutomatedDiscounts: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_GOOGLE_AUTOMATED_DISCOUNTS,
    ),
    fabricSample: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE,
    ),
  },
  products: {
    swatches: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_PRODUCTS_SWATCHES,
    ),
    videos: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_PRODUCTS_VIDEOS),
    staticPages: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_STATIC_PRODUCT_PAGES,
    ),
    dynamicPlp: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_DYNAMIC_PLP),
    v2Images: isFeatureEnabled(
      envConfig.NEXT_PUBLIC_FEATURES_PRODUCTS_V2_IMAGES,
    ),
  },
  marketSelector: {
    new: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_NEW_MARKET_SELECTOR),
  },
  cache: {
    loop: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_CACHE_LOOP),
  },
  datadog: {
    rum: isFeatureEnabled(envConfig.NEXT_PUBLIC_DATADOG_RUM),
  },
  next: {
    prefetch: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_LINK_PREFETCH),
  },
  elevate: isFeatureEnabled(envConfig.NEXT_PUBLIC_FEATURES_ELEVATE),
} as const;

function isFeatureEnabled(value?: string) {
  const compare = value?.localeCompare("true", undefined, {
    sensitivity: "accent",
  });

  return compare === 0;
}
